export function partnerOperationOpen(pic, menu) {
	return {
    type: 'PARTNER_OPERATION_CHECK',
    payload: {
			pic: pic,
			menu: menu,
		},
	}
}

export function partnerOperationClose() {
	return {
    type: 'PARTNER_OPERATION_CLOSE',
    payload: {

		},
	}
}
